import React, { useState } from "react";
import { Button, Field, Flex, SendIcon, TextInput } from "@aidnas/design-system";

import { useChatContext } from "../context/ChatContext";

import styles from "../Styles.module.scss";

export function ChatInput() {
  const [query, setQuery] = useState("");
  const { error, loading, onSubmit } = useChatContext();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    onSubmit(query.trim());
    setQuery("");
  };

  return (
    <form className={styles.chat_input_container} onSubmit={handleSubmit}>
      <Field>
        <Flex align="center" gap="spacing-100" horizontal justify="stretch">
          <TextInput
            aria-label="Chat input"
            className={styles.input}
            density="comfortable"
            disabled={loading}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Type your question…"
            type="text"
            value={query}
          />
          <Button
            aria-label="Send message"
            density="comfortable"
            disabled={!loading && !query.trim()}
            iconEnd={<SendIcon />}
            loading={loading}
            type="submit"
            variant="strong"
          />
        </Flex>
      </Field>
      {error && <div className={styles.error}>{error}</div>}
    </form>
  );
}
